import { memo } from 'react';

import type { Author, User } from '../../types/api';
import { AuthorAvatar } from '../AuthorAvatar';
import { getAuthorPseudo } from '../thread-utils';

export const FooterAuthorWithAvatar = memo((props: { author: Author }) => {
  const { author } = props;
  return (
    <div className="FooterAuthorWithAvatar flex items-center gap-x-[5px] overflow-hidden flex-1">
      <AuthorAvatar
        author={author}
        userId={(author as User).id}
        profile={(author as User).profile}
        size="small"
        withProfilePopover={false}
        style={{ height: '18px', width: '18px' }}
      />
      <span className="authorPseudo text-gray-graphite font-semibold truncate flex-1">
        {getAuthorPseudo(author)}
      </span>
    </div>
  );
});
